export default function ($translate) {
    return {
        KEYS: {
            DAY: 'DAY',
            WEEK: 'WEEK',
            MONTH: 'MONTH'
        },
        LABELS: {
            DAY: $translate.instant('training.interval.type.day'),
            WEEK: $translate.instant('training.interval.type.week'),
            MONTH: $translate.instant('training.interval.type.month')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/trainingTimeIntervalType/index.js